import {ImgHTMLAttributes, useEffect, useState} from "react";

// Нейтральна заглушка: працює і на темному, і на світлому фоні
const PLACEHOLDER_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" fill="none">
  <rect x="30" y="30" width="140" height="140" rx="28" fill="#808080" fill-opacity="0.12" stroke="#808080" stroke-opacity="0.35" stroke-width="2" stroke-dasharray="6 8"/>
  <g stroke="#808080" stroke-opacity="0.7" stroke-width="5" stroke-linecap="round" stroke-linejoin="round">
    <path d="M100 66l32 17v34l-32 17-32-17V83z"/>
    <path d="M68 83l32 17 32-17M100 100v34"/>
  </g>
</svg>`;

export const PRODUCT_PLACEHOLDER = `data:image/svg+xml;utf8,${encodeURIComponent(PLACEHOLDER_SVG)}`;

// Картинка товару: якщо фото немає або воно не завантажилось, показуємо заглушку.
// Це звичайний <img>, тому всі наявні стилі (розміри, радіуси) працюють без змін.
const ProductImage = ({ src, alt = "", ...rest }: ImgHTMLAttributes<HTMLImageElement>) => {
    const [failed, setFailed] = useState(false);

    // новий src — пробуємо завантажити знову
    useEffect(() => setFailed(false), [src]);

    const useFallback = !src || failed;

    return (
        <img
            // ~130 картинок одночасно вбивають пам'ять Safari на iPhone; ліниві вантажаться, лише коли наближаються до екрана
            loading="lazy"
            decoding="async"
            {...rest}
            src={useFallback ? PRODUCT_PLACEHOLDER : src}
            alt={alt}
            onError={() => setFailed(true)}
        />
    );
};

export default ProductImage;
